/**
 * 一个极简的mock的fetch库
 */
import defer from './Defer';
import {
  partial,
  each,
  get
} from 'lodash';


class EventHandler {
  static ajaxAbort(event, defer){

  }
  static ajaxError(event, defer){
    defer.reject(this);
  }
  static ajaxLoad(event, defer){

  }
  static ajaxLoadStart(event, defer){

  }
  static ajaxProgress(event, defer){

  }
  static ajaxTimeout(event, defer){

  }
  static ajaxLoadEnd(event, defer){
    defer.resolve(this);
  }
  static ajaxReadyStatusChange(event, defer){

  }
}

export default function MockFetch(url, {
  method= 'GET',
  headers = {},
  mode = 'cors',
  cache = 'default',
  body = {}
} = {}, events){

  let request = new XMLHttpRequest();

  let deferObject = defer();

  request.addEventListener('abort', partial(EventHandler.ajaxAbort, partial.placeholder, deferObject), false);

  request.addEventListener('error', partial(EventHandler.ajaxError, partial.placeholder, deferObject), false);

  request.addEventListener('load', partial(EventHandler.ajaxLoad, partial.placeholder, deferObject), false);

  request.addEventListener('loadstart', partial(EventHandler.ajaxLoadStart, partial.placeholder, deferObject), false);

  request.addEventListener('progress', partial(EventHandler.ajaxProgress, partial.placeholder, deferObject), false);

  request.addEventListener('timeout', partial(EventHandler.ajaxTimeout, partial.placeholder, deferObject), false);

  request.addEventListener('loadend', partial(EventHandler.ajaxLoadEnd, partial.placeholder, deferObject), false);

  request.addEventListener('readystatechange', partial(EventHandler.ajaxReadyStatusChange, partial.placeholder, deferObject), false);

  request.open(method, url, true);

  each(headers, function (value, key) {
    request.setRequestHeader(key, value)
  });

  if (mode === 'cors') {
    request.withCredentials = true;
  }

  if (events && events.progress) {
    //request.upload.onprogress = events.progress;
    request.upload.addEventListener('progress', events.progress, false);
  }

  request.send(body);

  return deferObject.promise;
}



// WEBPACK FOOTER //
// ./src/class/MockFetch.js